import * as React from "react";
import { motion } from "framer-motion";
import { useTheme } from "@/components/theme-provider";

interface CompanyLogoProps {
  logo: string;
  logoLight?: string;
  name: string;
  useLightInDark?: boolean;
}

export function CompanyLogo({ logo, logoLight, name, useLightInDark }: CompanyLogoProps) {
  const { theme } = useTheme();
  const isDark = theme === "dark";

  return (
    <motion.div
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      className="flex items-center justify-center p-4 rounded-lg transition-colors duration-200"
    >
      <img
        src={isDark && logoLight ? logoLight : logo}
        alt={`${name} logo`}
        className="h-12 w-auto object-contain"
      />
    </motion.div>
  );
} 